module.exports = __webpack_public_path__ + "img/turtle-fr.383af775.png";